const HYPHENS_CHAR = '\u2010';
const ELLIPSIS_CHAR = '…';

export { HYPHENS_CHAR, ELLIPSIS_CHAR };
